/**
 * Fragment de routes du paquet v2-p07-ecrans-espaces (vague V2). Composants chargés à la demande (règle de chargement
 * du registre), aucun code exécuté au chargement.
 * Routes du socle remplacées (`remplace: true`), d'après le `couvre: route:` des YAML d'écrans :
 *  - `/programme/membres` → programme-membres ; `/projet/membres` → projet-membres.
 *    Les écrans historiques `MembresProgramme` et `ProjetMembres` (screens/**) ne sont plus servis ; leurs fichiers et
 *    App.tsx (gelé) restent inchangés.
 * Routes neuves des sept dialogues (écrans pleins ; objet par `?programme=` / `?projet=`, personne par `?utilisateur=`) :
 *  - `/programme/membres/ajouter`, `/programme/membres/droit-isole` ;
 *  - `/projet/membres/ajouter`, `/projet/membres/inviter`, `/projet/membres/profils`, `/projet/membres/retirer`,
 *    `/projet/membres/droit-isole`.
 */
import { lazy, Suspense, type ComponentType, type JSX } from 'react'

import type { Session } from '../../auth/session'
import type { ContexteRoutes, FragmentRoutes } from './registre'

const ProgrammeMembres = lazy(() => import('../ecrans/v2/espaces/ProgrammeMembres'))
const ProjetMembres = lazy(() => import('../ecrans/v2/espaces/ProjetMembres'))
const DialogueAjouterMembreProgramme = lazy(() => import('../ecrans/v2/espaces/DialogueAjouterMembreProgramme'))
const DialogueAccorderDroitIsoleProgramme = lazy(() => import('../ecrans/v2/espaces/DialogueAccorderDroitIsoleProgramme'))
const DialogueAjouterMembreProjet = lazy(() => import('../ecrans/v2/espaces/DialogueAjouterMembreProjet'))
const DialogueInviterMembreProjet = lazy(() => import('../ecrans/v2/espaces/DialogueInviterMembreProjet'))
const DialogueChangerProfilMembreProjet = lazy(() => import('../ecrans/v2/espaces/DialogueChangerProfilMembreProjet'))
const DialogueRetirerMembreProjet = lazy(() => import('../ecrans/v2/espaces/DialogueRetirerMembreProjet'))
const DialogueAccorderDroitIsoleProjet = lazy(() => import('../ecrans/v2/espaces/DialogueAccorderDroitIsoleProjet'))

function ecran(Composant: ComponentType<{ session: Session }>) {
  return ({ session, t }: ContexteRoutes): JSX.Element => (
    <Suspense fallback={<p role="status">{t('v10.primitives.assemblage.chargement')}</p>}>
      <Composant session={session} />
    </Suspense>
  )
}

export const fragment: FragmentRoutes = {
  zone: 'v2-espaces',
  routes: [
    { chemin: '/programme/membres', element: ecran(ProgrammeMembres), remplace: true },
    { chemin: '/programme/membres/ajouter', element: ecran(DialogueAjouterMembreProgramme) },
    { chemin: '/programme/membres/droit-isole', element: ecran(DialogueAccorderDroitIsoleProgramme) },
    { chemin: '/projet/membres', element: ecran(ProjetMembres), remplace: true },
    { chemin: '/projet/membres/ajouter', element: ecran(DialogueAjouterMembreProjet) },
    { chemin: '/projet/membres/inviter', element: ecran(DialogueInviterMembreProjet) },
    { chemin: '/projet/membres/profils', element: ecran(DialogueChangerProfilMembreProjet) },
    { chemin: '/projet/membres/retirer', element: ecran(DialogueRetirerMembreProjet) },
    { chemin: '/projet/membres/droit-isole', element: ecran(DialogueAccorderDroitIsoleProjet) },
  ],
}
